export default {
  setNoticeList ({ commit }, payload) {
    commit('setNoticeList', payload)
  }
}
